import { takeLatest, put, select, all, call } from 'redux-saga/effects';
import { message } from 'antd';
import { fetchDashboard } from '@api/dashboards';
import { autoRequest } from '@api/createRequestStore';
import { APPLY_REQUEST } from '../request/types';
import { APPLY_TIMELINE_CONFIG } from '../config/types';
import { APPLY_TIMELINE_UI } from '../ui/types';
import * as configTypes from '../config/types';
import * as uiTypes from '../ui/types';
import * as requestTypes from '../request/types';
import * as actions from './actions';
import * as types from './types';
import { dashboardResponseSelector } from './selectors';
import { updateRequest } from '../utils';
import { buildRequest } from './utils';

function* init() {
  yield all([
    put({ type: configTypes.INIT }),
    put({ type: uiTypes.INIT }),
    put({ type: requestTypes.INIT }),
  ]);
}

function* apply(configStore) {
  try {
    const { request, config = {}, ui = {} } = configStore;

    yield call(init);
    yield all([
      put({
        type: APPLY_REQUEST,
        request,
      }),
      put({
        type: APPLY_TIMELINE_CONFIG,
        config,
      }),
      put({
        type: APPLY_TIMELINE_UI,
        ui,
      }),
    ]);
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* afterRequest() {
  const dashboard = yield select(dashboardResponseSelector);
  if (!dashboard) {
    return;
  }
  const { config } = dashboard;

  try {
    const { request, config: configStore, ui } = config;
    // update request time interval
    updateRequest(request);
    yield apply({ request, config: configStore, ui });
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching({ id }) {
  yield actions.fetching();
  try {
    yield autoRequest(fetchDashboard, types.SCOPE, id, afterRequest);
  } catch (error) {
    yield call(message.error, error.message || 'Unknown error.');
    throw error;
  }
}

export function* setupTimline({ query }) {
  const clientId = query.get('clientId');
  const sessionId = query.get('sessionId');
  const timelineInterval = query.get('timelineInterval');
  const isLiveSession = query.get('isLiveSession');

  let sessionStartTime = query.get('sessionStartTime');
  let sessionEndTime = query.get('sessionEndTime');

  // trends passes start time as ISO
  // VM passes start time as epoch
  // if it's epoch as string then convert to Number
  if (!isNaN(sessionStartTime)) {
    sessionStartTime = Number(sessionStartTime);
  }

  if (sessionEndTime && !isNaN(sessionEndTime)) {
    sessionEndTime = Number(sessionEndTime);
  }

  const request = buildRequest({
    clientId,
    sessionId,
    timelineInterval,
    sessionStartTime,
    sessionEndTime,
    isLiveSession: isLiveSession === 'true',
  });

  yield apply({ request });
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.GET_DASHBOARD], fetching);
}

function* watchSetup() {
  yield takeLatest([types.SETUP_TIMELINE], setupTimline);
}

export default [watchInitRequest, watchFetching, watchSetup];
